"use client";

import { useEffect } from "react";

/**
 * Глобальная регистрация service worker (/sw.js) для ВСЕХ посетителей.
 *
 * Зачем: чтобы Chrome / Samsung Internet считали сайт «устанавливаемым»
 * (PWA) и предлагали установку + создавали standalone-WebAPK, нужен
 * зарегистрированный SW с fetch-обработчиком. Раньше SW регистрировался
 * только в push-компонентах (когда юзер трогал уведомления) → у обычного
 * пользователя установки PWA не было.
 *
 * Регистрация отложена на `load`, чтобы не конкурировать за сеть с
 * первичной отрисовкой. Ошибки молча игнорируем (SW необязателен для работы).
 */
export function ServiceWorkerRegister() {
  useEffect(() => {
    if (typeof navigator === "undefined" || !("serviceWorker" in navigator)) return;
    const onLoad = () => {
      navigator.serviceWorker.register("/sw.js").catch(() => {
        /* SW не критичен — игнорируем (приватный режим, отказ и т.п.) */
      });
    };
    if (document.readyState === "complete") {
      onLoad();
    } else {
      window.addEventListener("load", onLoad, { once: true });
      return () => window.removeEventListener("load", onLoad);
    }
  }, []);

  return null;
}
